<template>
  <div class="outer-box">
    <h4>Reset Contact DND</h4>

    <div class="inner-box" style="text-align: left; width: 500px;">
      <select class="hl_input--wrap" type="text" v-model="feature">
        <!-- <option value="Email">Email</option> -->
        <option value="SMS">SMS</option>
        <option value="WhatsApp">WhatsApp</option>
      </select>
      <input class="mt-4 hl_input--wrap " type="text" placeholder="Contact ID" v-model="contactId" />
      <button class="btn btn-primary mt-4" @click="resetContactDND" :disabled="!contactId || isLoading">
        <moon-loader v-if="isLoading" :loading="true" size="21px" color="#fafafa" />
        <span v-else class="capitalize">Unlock {{feature}}</span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{
        response
      }}</pre>
    </div>
  </div>
</template>

<script>
import { SpmAppengineService } from '@/services';

export default {
  data() {
    return {
      contactId: "",
      feature: 'SMS',
      response: null,
      isLoading: false
    };
  },
  methods: {
    async resetContactDND() {
      this.isLoading = true;
      try {
        const { data } = await SpmAppengineService.resetContactDND({
          contactId:this.contactId.trim(),
          feature:this.feature
        })
        this.response = data.msg
        this.isLoading = false
      } catch (err) {
        this.isLoading = false
        this.response =  err.response ? err.response.data.msg : err.message
      }
    }
  }
};
</script>

<style scoped>
 .capitalize {
  text-transform: capitalize;
 }
</style>
